module.exports = __webpack_public_path__ + "static/media/cash.7f998bbb.png";